/**
 * Cross-host link builders for the marketing ↔ app domain split
 * (dockstash.com serves marketing, app.dockstash.com serves the dashboard).
 *
 * When VITE_APP_URL / VITE_SITE_URL are unset (dev, tests, single-origin
 * self-host installs) both builders return the path unchanged, so links stay
 * relative and behavior is identical to a single-origin deploy.
 */
const APP_ORIGIN: string = ((import.meta.env.VITE_APP_URL as string | undefined) ?? '').replace(
  /\/$/,
  '',
);
const SITE_ORIGIN: string = ((import.meta.env.VITE_SITE_URL as string | undefined) ?? '').replace(
  /\/$/,
  '',
);

/** Absolute link into the authenticated app shell (login/register/dashboard). */
export const appHref = (path: string): string => `${APP_ORIGIN}${path}`;

/** Absolute link back to the marketing site (terms/privacy from app pages). */
export const siteHref = (path: string): string => `${SITE_ORIGIN}${path}`;

/**
 * Full-page navigation seam. Cross-host jumps must replace the document (the
 * SPA router cannot cross origins), and jsdom's `window.location.assign` is
 * read-only — an isolated one-liner keeps component tests mockable (same
 * pattern as `redirectToOAuth` in features/auth/oauth.ts).
 */
export const assignLocation = (url: string): void => {
  window.location.assign(url);
};
